import React from 'react';
import CustomButton from '../Button/CustomButton';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface TalentFilterToggleProps {
    isOpen: boolean;
    onToggle: () => void;
}

const TalentFilterToggle: React.FC<TalentFilterToggleProps> = ({ isOpen, onToggle }) => {
    const { themeStyle } = useThemeContext();
    return (
        <CustomButton
            onClick={onToggle}
            buttonProps={{ variant: 'outlined' }}
            label={isOpen ? 'Hide Filters' : 'Show Filters'}
            customStyle={{
                borderRadius: '5px',
                borderColor: theme[themeStyle].highlight,
            }}
            textStyle={{
                color: theme[themeStyle].tag_white,
                fontFamily: FONT_ENUM.MAIN_MEDIUM,
            }}
            sx={{
                '&:hover': {
                    backgroundColor: 'none',
                },
            }}
        />
    );
};

export default TalentFilterToggle;
